/**
 * 입력 상자 (ops/dev/TODO DEV-18b, 사용자 2026-10-18). 멘션 칩 · 글 칸을 한 상자로 묶어 포커스 테두리를 상자 하나에만 그립니다.
 * 안의 칸(textarea · 칩 버튼)은 따로 테두리를 그리지 않고, 어디에 포커스가 가도 상자 전체가 하이라이트됩니다(styles/style.css .input-box).
 * 별채 · 1:1 · 고민 글 · 카운터 입력창이 같이 씁니다. 모양(반경 · 테두리 · 바탕)은 부르는 쪽 className 그대로.
 */
export function InputBox({ className = '', children }) {
    return <div className={`input-box ${className}`}>{children}</div>;
}
